module.exports = __webpack_public_path__ + "static/media/protein-shake-bottle2.493267cf.svg";